<template>
  <BaseDialog :isOpen="isOpen">
    <template v-slot:title>
      Are you sure you want to close the role?
    </template>
    <template v-slot:body>
      <div class="close-booking-description">
        Closing the role will mean that no-one else can apply to this role.
      </div>
    </template>
    <template v-slot:actions>
      <div class="booking-actions">
        <PrimaryButton @click.native="close" text>
          Cancel
        </PrimaryButton>
        <PrimaryButton @click.native="handleSubmit" :loading="isLoading">
          Close Role
        </PrimaryButton>
      </div>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from "@/components/common/BaseDialog";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import {
  BOOKINGS_NAMESPACE,
  CLOSE_BOOKING
} from "@/store/modules/bookings/actions";
import { createNamespacedHelpers } from "vuex";

const { mapActions } = createNamespacedHelpers(BOOKINGS_NAMESPACE);

export default {
  name: "CloseBookingDialog",
  components: { PrimaryButton, BaseDialog },
  data() {
    return {
      isLoading: false
    };
  },
  props: {
    isOpen: Boolean
  },
  inject: ["currentBookingId"],
  methods: {
    ...mapActions({
      closeBooking: CLOSE_BOOKING
    }),
    async handleSubmit() {
      this.isLoading = true;
      await this.closeBooking(this.currentBookingId);
      this.close();
      this.isLoading = false;
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss">
.close-booking-description {
  min-height: 80px;
  color: $secondary-text;
}
</style>
